module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.barClasses,
    style: ({
      width: _vm.progress + '%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }, [_c('span', [(_vm.showValue) ? [_vm._v("\n        " + _vm._s(_vm.progress) + "%\n      ")] : _vm._e(), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c33504f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/progress-bar.vue
// module id = 714
// module chunks = 85